/**
 * @generated SignedSource<<589203e0412bb95abcb049c42247ec82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClipsPanel_ClipCard_clip$data = {
  readonly creator: {
    readonly fullName: string;
    readonly id: string;
  } | null;
  readonly id: string;
  readonly isFavourite: boolean;
  readonly lastEditedBy: {
    readonly fullName: string;
    readonly id: string;
  } | null;
  readonly meetingRecordedVideoDuration: number | null;
  readonly meetingRecordedVideoPosterUrl: string | null;
  readonly meetingRecordedVideoUrl: string | null;
  readonly summary: string | null;
  readonly title: string;
  readonly viewerCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"ClipsPanel_DeleteClipModal_clip" | "ClipsPanel_RenameClipModal_clip" | "utils_useGetURL_recording">;
  readonly " $fragmentType": "ClipsPanel_ClipCard_clip";
};
export type ClipsPanel_ClipCard_clip$key = {
  readonly " $data"?: ClipsPanel_ClipCard_clip$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClipsPanel_ClipCard_clip">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClipsPanel_ClipCard_clip",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingRecordedVideoDuration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingRecordedVideoPosterUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingRecordedVideoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFavourite",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "lastEditedBy",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "utils_useGetURL_recording"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ClipsPanel_RenameClipModal_clip"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ClipsPanel_DeleteClipModal_clip"
    }
  ],
  "type": "MeetingRecordingClip",
  "abstractKey": null
};
})();

(node as any).hash = "1f83c80e6a8c7f00c5d495047719c126";

export default node;
